// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Pjtq","dragIcon":"SortableItem_dragIcon__24RFV","disabled":"SortableItem_disabled__9LF7o"};